// @flow
import React from 'react';
import PropTypes from 'prop-types';
import AbstractReactComponent from './../AbstractReactComponent';
import ApiObjectSuggestField from './../field/ApiObjectSuggestField';
import ObjektApi from './../api/gen/objekty/ObjektApi';
import {COMPONENT_CHILDREN} from './../Utils2';

/**
 * Field pro fulltextové hledání objektů.
 */
class ObjektField extends AbstractReactComponent {

    static PropTypes = {
        addonsBefore: COMPONENT_CHILDREN,
        addonsAfter: COMPONENT_CHILDREN,
        apiRequestDelay: PropTypes.number,
        customFetch: PropTypes.func,
        renderSuggestion: PropTypes.func,
        kodObce: PropTypes.string, // omezení hledání za kód obce
        ku: PropTypes.string, // omezení hledání za kód katastrálního území
        zakladniTyp: PropTypes.arrayOf(PropTypes.string), // omezení hledání dle základního typu objektu
        typ: PropTypes.arrayOf(PropTypes.string), // omezení hledání dle kódů typů objektů
        zdroj: PropTypes.arrayOf(PropTypes.string), // omezení hledání na zdroj dat
        max: PropTypes.number // omezení počtu vrácených záznamů
    };

    static defaultProps = {
        apiRequestDelay: 250,
        max: 1000
    };

    handleFilterSuggestions = (value) => {
        const {customFetch, kodObce, ku, zakladniTyp, typ, zdroj, max} = this.props;
        if (value && value !== "") {
            if (customFetch && typeof customFetch === "function") {
                return customFetch(value);
            }
            return ObjektApi.findObjektFulltext(value, kodObce, ku, zakladniTyp, typ, zdroj, max);
        }
        return Promise.resolve([]);
    };

    renderObjekt = (i, active, getItemValue) => {
        console.log(i);
        return <div className={active ? "active" : ""}>
            {i.objekt.popis && i.objekt.popis }
        </div>
    };

    render() {
        const {renderSuggestion, ...other} = this.props;
        return <ApiObjectSuggestField
            dropdown
            minCharsForFilter={3}
            placeholder="Vyhledat objekt"
            filterSuggestions={this.handleFilterSuggestions}
            getItemValue={(item) => item ? item.popis : ""}
            renderSuggestion={ renderSuggestion ? renderSuggestion : this.renderObjekt }
            {...other}
        />
    }
}
export default ObjektField;
